import { Icon } from "@atoms";
import { faIcon } from "@utils/faIcon";
import { Component } from 'react';
import WrapperLinkButton from '../../core/buttons/WrapperLinkButton';
import { convertToKebabCase, formatCurrencyForServiceCompany } from '../../core/utils/utils';


class BillObjectLink extends Component {

    render() {
        const { bill, destination } = this.props

        const buttonTitle = `Bill ${bill.id} [${bill.status_label}]`
        const buttonPillClass = `bills-${convertToKebabCase(bill.status_label)}`
        const buttonPillLabel = bill.status_label
        const buttonLabel = formatCurrencyForServiceCompany(bill.subtotal, bill.service_company)
        const billId = bill.custom_id || bill.id

        return (
            <WrapperLinkButton type="object_link" destination={destination} openNew={true} title={buttonTitle} ariaLabel="View Bill">
                <div className="data-panel__list-select__option__label"><div className={`data-panel__list-select__option__status-pill ${buttonPillClass}`}>{buttonPillLabel}</div><span>{billId} • {buttonLabel}</span></div><div className="data-panel__list-select__option__icon"><Icon containerClassName="icon-inline" icon={faIcon({ name: "angle-right", style: "regular" })} /></div>
            </WrapperLinkButton>
        )
    }
}

export default BillObjectLink;
